import {
  Component,
  inject,
  Injector,
  OnInit,
  runInInjectionContext,
} from '@angular/core';
import { Auth, User, user } from '@angular/fire/auth';
import { UntilDestroy, untilDestroyed } from '@ngneat/until-destroy';
import { Store } from '@ngrx/store';
import { tap } from 'rxjs';

import {
  resetAuth,
  setAuthToken,
  setAuthUser,
  toAuthTokenClaims,
} from '@vmspdb/ui/store';

import { FirebaseUser } from '@vmspdb/ui/domain';

// import * as LogRocket from 'logrocket';

@UntilDestroy()
@Component({
  template: '',
  standalone: false,
})
export class CommonAppComponent implements OnInit {
  protected store = inject(Store);
  private auth = inject(Auth);
  protected injector = inject(Injector);

  ngOnInit(): void {
    runInInjectionContext(this.injector, () => {
      user(this.auth)
        .pipe(
          untilDestroyed(this),
          tap((userObject) => {
            if (!userObject) {
              // No specific route being protected here - this fires once
              // per boot for a signed-out session, not in response to a
              // guard redirect - so there is no return url to carry.
              this.store.dispatch(resetAuth({}));
              return;
            }
            this.setCurrentUser(userObject);
          }),
        )
        .subscribe();
    });
  }

  private setCurrentUser(u: User) {
    this.store.dispatch(setAuthUser({ user: u.toJSON() as FirebaseUser }));
    u.getIdTokenResult().then((result) => {
      this.store.dispatch(setAuthToken({ token: toAuthTokenClaims(result) }));
    });
  }
}
